import type { SupportCase, SupportCaseStatus } from '../models/SupportCase';
import type { TFunction } from 'i18next';

export function supportCaseByChatId(
  cases: readonly SupportCase[],
  chatId: string | null | undefined
): SupportCase | undefined {
  if (!chatId) return undefined;
  return cases.find((entry) => entry.chatId === chatId);
}

export function supportCaseSubjectByChatId(
  cases: readonly SupportCase[],
  chatId: string | null | undefined
): string | undefined {
  const subject = supportCaseByChatId(cases, chatId)?.subject?.trim();
  return subject || undefined;
}

export function supportCaseStatusLabel(status: SupportCaseStatus, t: TFunction): string {
  switch (status) {
    case 'OPEN':
      return t('supportCases.status.open', 'Open');
    case 'RESOLVED':
      return t('supportCases.status.resolved', 'Resolved');
    case 'CLOSED':
      return t('supportCases.status.closed', 'Closed');
    default:
      return status;
  }
}
